// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"c96b9375","388":"feae8a6b","396":"fa11b5e8","488":"e1e95bee","512":"04cc4434","528":"f0ea7f38","596":"2a32c469","780":"341f77b8","808":"feec07d9","852":"bf4d9b93","872":"8e438fdd"}[chunkId] + ".chunk.js";
};